import { RootActions, RootState } from "common/reducers";
import {
  REMOVE_FORM,
  UPDATE_FORM,
  UPDATE_FORM_ERROR,
  UPDATE_FORM_ERRORS,
  REMOVE_FORM_KEY,
  PUSH_ID,
  REMOVE_ID,
  ON_SORT_END,
} from "common/reducers/rsfForm.actions";
import { IdType } from "common/types";
import { parsePath } from "common/helpers/FormPath";
import { Map, Record } from "immutable";

export const RsfFormRecord = Record({
  byForm: Map<string, Map<string, any>>(),
  errors: Map<string, Map<string, any>>(),
});

export const initialState = RsfFormRecord();
export type RsfFormState = typeof initialState;

const model = "rsfForms";
export const formRootPath = [model, "byForm"];
export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case UPDATE_FORM: {
      const { rootPath, name, value } = action.payload.event;
      return state.setIn(rootPath.concat(parsePath(name)), value);
    }

    case REMOVE_FORM: {
      const { formName } = action.payload;
      return state.deleteIn([model, "byForm", formName]);
    }

    case UPDATE_FORM_ERROR: {
      const { rootPath, name, error } = action.payload.event;
      return state.setIn([model, "errors", ...rootPath, name], error);
    }

    case UPDATE_FORM_ERRORS: {
      const { rootPath, errors } = action.payload.event;
      return state.setIn([model, "errors", ...rootPath], errors);
    }

    case REMOVE_FORM_KEY: {
      const { rootPath, name } = action.payload;
      const fullPath = rootPath.concat(parsePath(name));
      return state.deleteIn(fullPath);
    }

    case PUSH_ID: {
      const { rootPath, name, value } = action.payload.event;
      const fullPath = rootPath.concat(parsePath(name));
      return state.updateIn(fullPath, (ids) => ids.push(value));
    }

    case REMOVE_ID: {
      const { rootPath, name, value } = action.payload.event;
      const fullPath = rootPath.concat(parsePath(name));
      return state.updateIn(fullPath, (ids) => ids.filter((existingId: IdType) => existingId !== value));
    }

    case ON_SORT_END: {
      const { rootPath, name, oldIndex, newIndex } = action.payload.event;
      const fullPath = rootPath.concat(parsePath(name));
      return state.updateIn(fullPath, (ids) => ids.delete(oldIndex).insert(newIndex, ids.get(oldIndex)));
    }

    default:
      return state;
  }
};
